import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import * as generic from '../../../components/Generico';
import { JuridicaService } from '../../../service/JuridicaService';
import { InputComponent } from '../../../components/InputComponent';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { FileComponent } from '../../../components/FileComponent';
import { Dialog } from 'primereact/dialog';
import { AnexosComponent } from '../../../components/AnexosComponent';
import { JuridicaDeclaracion } from '../../../models/ficha/JuridicaDeclaracion';
import { CatalogoService } from '../../../service/CatalogoService';
import { Pago } from '../Pago';
import { Message } from 'primereact/message';
import { Tercero } from '../Tercero';
import { BottomActionBar } from '../../../components/ui/BottomActionBar';

export const Declaracion = ({ toast, id, permss, setDialogInstruccion, urls, estado, reiniciar, soloLectura, catalogos, back }) => {

    const esTipoEspecial = ['FRM_TOYOTA', 'FRM_DIFARE'].includes(catalogos?.tipoFrmEmpresa);
    const omodel = new JuridicaDeclaracion();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue } = useForm({ defaultValues });
    const juridicaSrv = new JuridicaService();
    const catalogoSrv = new CatalogoService();
    const { inText, inNumber, inArea, inDrop, inCalendar } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const { enviarFormulario } = FileComponent({ tipo: 'juridica', toast, unuevo: 'ficha/juridica/store', udelete: 'ficha/juridica/eliminar-anexo', permss, id });
    const [loadReport, setLoadReport] = useState(false);
    const [dialogAnexos, setDialogAnexos] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [ecuador, setEcuador] = useState(false);
    const [ciudades, setCiudades] = useState([]);
    const [siFormaPago, setSiFormaPago] = useState(false);
    const [siPago, setSiPago] = useState(false);
    const [esNuevoAccionista, setEsNuevoAccionista] = useState(false);

    useEffect(() => {
        editarFicha();
        // eslint-disable-next-line
    }, [id]);

    const editarFicha = () => {
        setIsLoading(true);
        juridicaSrv.consultarJuridica(id, 'seccion4').then(res => {
            const _juridica = res.data.juridica;
            if (!_juridica) {
                return;
            }
            setEcuador(_juridica.pais_pago?.cat_id === catalogos.ecuador?.cat_id);
            if (res.data.ciudad_pago) {
                setCiudades(res.data.ciudad_pago);
            }
            setEsNuevoAccionista(_juridica?.nuevo_accionista ?? false);
            setSiPago(_juridica?.totalForma > 0);
            _juridica.fecha_transaccion = generic.stringToDate(_juridica.fecha_transaccion);
            reset(generic.renewValues(_juridica, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onSubmit = (data) => {
        data.id = id;
        data.seccion = 'seccion4';
        data.ec = catalogos.ecuador.cat_id;
        data.fecha_transaccion = generic.dateToString(data.fecha_transaccion);
        data.esNuevoAccionista = esNuevoAccionista;
        setIsSaving(true);
        juridicaSrv.editarJuridica(data).then(res => {
            setDialogInstruccion(true);
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => {
            setIsSaving(false);
        });
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const generarReporte = () => {
        setLoadReport(true);
        juridicaSrv.descargar(id, { tipoFrmEmpresa: catalogos?.tipoFrmEmpresa ?? '' }).then(res => {
            generic.downloadPdf(res, id + '-Formulario-Persona-Juridica.pdf');
        }).catch(error => {
            generic.funcMessageBlobError('Complete la información antes de generar.', error, toast);
        }).finally(() => setLoadReport(false));
    }

    const subirReporte = () => {
        setDialogAnexos(true);
    }

    const enviar = () => {
        enviarFormulario(id, 'ficha/juridica/enviar?tipoFrmEmpresa=' + (catalogos?.tipoFrmEmpresa ?? ''), 'juridica');
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    const onChangePais = (e) => {
        setEcuador(e.value?.cat_id === catalogos.ecuador?.cat_id);
        setValue('provincia_pago', null);
        setValue('ciudad_pago', null);
        setCiudades([]);
    }

    const onChangeProvincia = (e) => {
        setValue('ciudad_pago', null);
        if (!e?.value) {
            setCiudades([]);
            return;
        }
        catalogoSrv.getCatalogosId(e.value.cat_id).then(res => {
            setCiudades(res.data);
        });
    }

    const onChangeTipoEntrega = (e) => {
        setSiFormaPago(e.value?.cat_id === catalogos?.beneficiario?.cat_id || e.value?.cat_id === catalogos?.tercero?.cat_id);
    }

    const totalTercero = (_total) => {
        setSiPago(_total > 0);
    }

    return (
        <>
            <form id="declaracionJuridicaForm" onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
                {esNuevoAccionista && (
                    <Panel header={generic.renderPanelHeader('B.1', 'DECLARACIÓN DE ORIGEN LÍCITO DE FONDOS (SÓLO PARA NUEVOS ACCIONISTAS)', 'pi pi-file-edit')} className="panel-ficha shadow-1 mb-4">
                        <div className="formgrid grid">
                            {inText('descripcion_transaccion', { icon: 'pi pi-file-edit' }, 3)}
                            {inNumber('monto', 2, true, { icon: 'pi pi-dollar' }, 3)}
                            {inDrop('moneda', catalogos?.moneda, { lab: 'nombre' }, 3)}
                            {inCalendar('fecha_transaccion', {}, 3)}
                            {inDrop('pais_pago', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais, val: false }, 4)}
                            {ecuador ? (
                                <>
                                    {inDrop('provincia_pago', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia, val: false }, 4)}
                                    {inDrop('ciudad_pago', ciudades, { lab: omodel.optionLabel }, 4)}
                                </>
                            ) : (
                                inText('canton_pago', { icon: 'pi pi-map-marker' }, 8)
                            )}
                        </div>

                        <Pago tipo="juridica" id={id} permss={permss} toast={toast} soloLectura={soloLectura} tipoFrmEmpresa={catalogos?.tipoFrmEmpresa ?? null} />

                        <div className="formgrid grid mt-2">
                            {inText('valor_fuente', { icon: 'pi pi-dollar' }, 8)}
                            {inDrop('valor_entregado', catalogos?.entregado, { lab: omodel.optionLabel, chn: onChangeTipoEntrega, ne: siPago ? 'disabled' : '' }, 4)}
                        </div>

                        {siFormaPago && (
                            <Panel header={generic.renderPanelHeader('5', 'BENEFICIARIO FINAL / TERCEROS', 'pi pi-users')} className="panel-ficha shadow-1 mt-4 mb-2">
                                <Message severity="info" text="En caso de señalar Beneficiario Final o Tercero/s complete lo siguiente:" style={{ width: '100%' }} className="mb-3" />
                                <Tercero tipo="juridica" id={id} permss={permss} toast={toast} lista={catalogos} soloLectura={soloLectura} totalTercero={totalTercero} />
                            </Panel>
                        )}
                    </Panel>
                )}

                <Panel header={generic.renderPanelHeader('B.2', 'DECLARACIÓN DE ORIGEN LÍCITO DE FONDOS', 'pi pi-file-edit')} className="panel-ficha shadow-1 mb-4">
                    <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-0">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-info-circle text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Términos de la Declaración</span>
                        </div>
                        {omodel.strDeclara}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('B.3', catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' ? 'TRATAMIENTO DE DATOS PERSONALES' : 'AUTORIZACIÓN PARA TRATAMIENTO DE DATOS', 'pi pi-lock')} className="panel-ficha shadow-1 mb-4">
                    <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-0">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-shield text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Tratamiento de Datos Personales</span>
                        </div>
                        {!esTipoEspecial && omodel.strAutorizacionTratamientoDatos}
                        {catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' && omodel.strToyota}
                        {catalogos?.tipoFrmEmpresa === 'FRM_DIFARE' && omodel.strDifare}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('8', 'Anexos', 'pi pi-paperclip')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid">
                        <div className="field col-12 md:col-6 p-3 text-justify line-height-3 text-700 bg-yellow-50 border-round border-left-3 border-yellow-500">
                            <div className="flex align-items-center gap-2 mb-3">
                                <i className="pi pi-file text-yellow-600 text-lg"></i>
                                <span className="font-bold text-yellow-900">Persona Jurídica Nacional</span>
                            </div>
                            <ul className="pl-4 m-0">
                                {catalogos?.anexosRequisitosNacional?.map((req, index) => (
                                    <li key={index} className="mb-1">{req}</li>
                                ))}
                            </ul>
                        </div>
                        <div className="field col-12 md:col-6 p-3 text-justify line-height-3 text-700 bg-yellow-50 border-round border-left-3 border-yellow-500">
                            <div className="flex align-items-center gap-2 mb-3">
                                <i className="pi pi-file text-yellow-600 text-lg"></i>
                                <span className="font-bold text-yellow-900">Persona Jurídica Extranjera</span>
                            </div>
                            <ul className="pl-4 m-0">
                                {catalogos?.anexosRequisitosExtranjero?.map((req, index) => (
                                    <li key={index} className="mb-1">{req}</li>
                                ))}
                            </ul>
                        </div>

                        {esTipoEspecial && (
                            <div className="field col-12 p-3 text-justify font-bold line-height-3 text-xs bg-yellow-50 border-round border-left-3 border-yellow-500 mt-3 mb-0">
                                {omodel.msgAnexo}
                            </div>
                        )}
                    </div>
                </Panel>

                {!esTipoEspecial && (
                    <Panel header={generic.renderPanelHeader('10', 'OBSERVACIONES', 'pi pi-comment')} className="panel-ficha shadow-1 mb-4">
                        <div className="formgrid grid">
                            {inArea('observacion', 5, 9000, 12)}
                        </div>
                    </Panel>
                )}

                <BottomActionBar
                    formId="declaracionJuridicaForm"
                    onPrev={back}
                    onSave={true}
                    onGenerate={generarReporte}
                    onSend={enviar}
                    onAttachments={subirReporte}
                    loading={isSaving || loadReport}
                    isReadOnly={soloLectura}
                    enableExtras={id != null}
                />
            </form>
            <Dialog visible={dialogAnexos} header="Gestión de Anexos" modal className="p-fluid modal-ssize" onHide={() => setDialogAnexos(false)} style={{ width: '800px' }}>
                <AnexosComponent tipo="juridica" urls={urls} idp={id} toast={toast} permss={permss} setDialogSubir={setDialogAnexos} reiniciar={reiniciar} estado={estado} soloLectura={soloLectura} />
            </Dialog>
        </>
    );
}
